/**
 * Add to Cart Action
 * Triggered by: arc:action:addToCart
 */

import {
  clickCollectLineItemProperties,
} from '@js/utils/clickCollectCartAttributes';
import { resolveCurrentStoreVariantId } from '@js/utils/variantResolver';

export const runAddToCart = async (data = {}) => {
  try {
    let {
      variantId,
      quantity = 1,
      properties = {},
      productHandle,
      product: productContext = null,
      selectedVariant = null
    } = data;

    if (!variantId) {
      throw new Error('Variant ID is required and could not be determined from product context');
    }

    // EU migration: SearchSpring/cache can provide source-store variant IDs; resolve against the current store before cart add.
    variantId = await resolveCurrentStoreVariantId({
      variantId,
      productHandle,
      product: productContext,
      selectedVariant
    });

    const clickCollectStore = window.Alpine?.store('clickCollect');
    const pickupBoutique = data.boutique || clickCollectStore?.pdpPickupBoutique;

    if (pickupBoutique) {
      properties = {
        ...properties,
        ...clickCollectLineItemProperties(pickupBoutique),
      };
    }

    window.dispatchEvent(new CustomEvent('cart:add_loading_start', { detail: { variantId, quantity } }));

    await Alpine.store('cart').add(variantId, quantity, properties);

    if (pickupBoutique) {
      clickCollectStore.setDeliveryMethod('click_and_collect');
      const skus = data.variantSku ? [data.variantSku] : (data.skus || []);
      await clickCollectStore.applyBoutiqueSelection(pickupBoutique, skus);
      if (!data.boutique) {
        clickCollectStore.setPdpPickupBoutique(null);
      }
    }

    window.dispatchEvent(new CustomEvent('cart:item_added', { detail: { variantId, quantity } }));
    window.dispatchEvent(new CustomEvent('cart:add_loading_end'));
    window.dispatchEvent(new CustomEvent('arc:action:addToCart:success', { detail: { variantId, quantity } }));

    return {
      success: true,
      message: 'Item added to cart successfully'
    };
  } catch (error) {
    console.error('Error adding to cart:', error);
    window.dispatchEvent(new CustomEvent('cart:add_loading_end'));
    window.dispatchEvent(new CustomEvent('arc:action:addToCart:error', { detail: { error: error.message } }));
    return {
      success: false,
      error: error.message
    };
  }
};

export default runAddToCart;
